import { render } from "./WebDesign.vue?vue&type=template&id=23b131db&scoped=true"
import script from "./WebDesign.vue?vue&type=script&lang=js"
export * from "./WebDesign.vue?vue&type=script&lang=js"

import "./WebDesign.vue?vue&type=style&index=0&id=23b131db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b131db"]])

export default __exports__